import { Link } from 'react-router-dom';
import { hotRecommends } from '@/mocks/home';

export default function HotRecommend() {
  return (
    <section className="py-12 md:py-16" aria-label="热门推荐">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              大家都在看的精彩内容
            </p>
          </div>
          <Link
            to="/category/dianying"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {hotRecommends.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-medium">
                    {item.badge}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 px-1.5 py-0.5 rounded bg-background-950/60 backdrop-blur-sm">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[10px] text-accent-400"></i>
                  </div>
                  <span className="text-[10px] text-background-50 font-medium">
                    {item.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {item.category} · {item.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}